/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Fill_Below_HintInputs */

const en_us2_workout_logging_fill_below_hint = /** @type {(inputs: Workout_Logging_Fill_Below_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copies load and reps into the sets still to do`)
};

const pt_br2_workout_logging_fill_below_hint = /** @type {(inputs: Workout_Logging_Fill_Below_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia carga e repetições para as séries que faltam`)
};

const es_419_workout_logging_fill_below_hint = /** @type {(inputs: Workout_Logging_Fill_Below_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia el peso y las repeticiones a las series que faltan`)
};

const pt_pt2_workout_logging_fill_below_hint = /** @type {(inputs: Workout_Logging_Fill_Below_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia carga e repetições para as séries que faltam`)
};

const fr_fr2_workout_logging_fill_below_hint = /** @type {(inputs: Workout_Logging_Fill_Below_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copie la charge et les répétitions dans les séries restantes`)
};

const de_de2_workout_logging_fill_below_hint = /** @type {(inputs: Workout_Logging_Fill_Below_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übernimmt Gewicht und Wdh. in die noch offenen Sätze`)
};

const it_it2_workout_logging_fill_below_hint = /** @type {(inputs: Workout_Logging_Fill_Below_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia carico e ripetizioni nelle serie ancora da fare`)
};

/**
* | output |
* | --- |
* | "Copies load and reps into the sets still to do" |
*
* @param {Workout_Logging_Fill_Below_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_fill_below_hint = /** @type {((inputs?: Workout_Logging_Fill_Below_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Fill_Below_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_fill_below_hint(inputs)
	if (locale === "es-419") return es_419_workout_logging_fill_below_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_fill_below_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_fill_below_hint(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_fill_below_hint(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_fill_below_hint(inputs)
	return en_us2_workout_logging_fill_below_hint(inputs)
});
export { workout_logging_fill_below_hint as "workout-logging.fill_below_hint" }